document.addEventListener("DOMContentLoaded", function() {
    var enquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
    if (enquiryList == null || undefined) {
        localStorage.setItem('enquirylist', '[]');
    }
});

const enquiryFocusableElements = ['input' , 'button' , '[href]', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
let enquiryList = document.querySelector('.enquiry-list');
let firstFocusableEnquiryElement = enquiryList.querySelectorAll(enquiryFocusableElements)[0];
let focusableEnquiryContent =  enquiryList.querySelectorAll(enquiryFocusableElements);
let lastFocusableEnquiryElement = focusableEnquiryContent[focusableEnquiryContent.length - 1];
var openEnquiryListInitiator;

let products = document.getElementsByClassName("product-card");
let enquiryUL = document.getElementById("enquiry-list-ul");
let noItems = document.createElement("p");
noItems.classList.add('weight-medium', 'medium-body' , 'sj-bw-e0e');
noItems.textContent = 'There are no items in your used machinery enquiry list.';

let enquiryListFragment = new DocumentFragment();

const openEnquirySidebar = (e) => {
    openEnquiryListInitiator = e.currentTarget;
    let enquiryList = document.querySelector('.enquiry-list');
    let docBody = document.body;
    enquiryList.classList.add('is-open');
    docBody.classList.add('overflow-hidden');
    let firstfocusableElement = enquiryList.querySelector('.close-enquiry-sidebar');
    firstfocusableElement.focus();
}

const closeEnquirySidebar = (e) => {
    let enquiryList = document.querySelector('.enquiry-list');
    let docBody = document.body;
    enquiryList.classList.remove('is-open');
    docBody.classList.remove('overflow-hidden');
    document.querySelector('.open-enquiry-list').focus();
    openEnquiryListInitiator.focus();
}

document.addEventListener('keydown', function(e) {
    if(enquiryList.classList.contains('is-open')){
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

        if(isEscPressed){
            closeEnquirySidebar();
        }
        
        if (!isTabPressed) {
            return;
        }
        
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableEnquiryElement) {
                lastFocusableEnquiryElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableEnquiryElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
            firstFocusableEnquiryElement.focus(); // add focus for the first focusable element
            e.preventDefault();
            }
        }
    }
});

function enquirylistcount() {
    let latestEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
    let count = latestEnquiryList.length;
    let elementCount = document.getElementById("enquiry-list-count");
    if(count == '0'){
        elementCount.textContent = '0';
    } else{
        elementCount.textContent = count;
    }
}

function addEnquiryItem(enquiryitem, index) {
    noItems.remove();
    let enquiryListCard = document.createElement("li");
    enquiryListCard.classList.add("enquiry-list-card");
    enquiryListCard.setAttribute('data-item-index', index);
    enquiryListCard.setAttribute('item-id', enquiryitem.itemID);

    let enquiryListCardImgContainer = document.createElement("figure");
    enquiryListCardImgContainer.classList.add("enquiry-list-card-img");
    let enquiryListCardImg = document.createElement("img");
    enquiryListCardImg.setAttribute('src', enquiryitem.itemImg);
    enquiryListCardImgContainer.append(enquiryListCardImg);
    enquiryListCard.append(enquiryListCardImgContainer);

    let enquiryListCardInfo = document.createElement("div");
    enquiryListCardInfo.classList.add("enquiry-list-card-info" , "machine-info");

    let dataItems = enquiryitem.itemdata

    let labelsToRetrieve = ['model' , 'brand' , 'price' , 'reference' , 'serialno'];

    labelsToRetrieve.forEach(function(label) {

        dataItems.forEach(function(item) {
            let lowerCaseName = item.data_item[0].toLowerCase();
            if(label == lowerCaseName){
                let enquiryListCardInfoItem = document.createElement("div");
                enquiryListCardInfoItem.classList.add("info-item");

                let enquiryListCardInfoItemName = document.createElement("h6");
                enquiryListCardInfoItemName.textContent = item.data_item[0];

                let enquiryListCardInfoItemValue = document.createElement("span");
                enquiryListCardInfoItemValue.textContent = item.data_item[1];
    
                enquiryListCardInfoItem.append(enquiryListCardInfoItemName);
                enquiryListCardInfoItem.append(enquiryListCardInfoItemValue);
    
                enquiryListCardInfo.append(enquiryListCardInfoItem);
            }
            
        });
    });

    let enquiryListCardActions = document.createElement("div");
    enquiryListCardActions.classList.add('item-actions');

    let enquiryListCardDelete = document.createElement("button");
    let enquiryListCardDeleteIcon = document.createElement("i");
    enquiryListCardDeleteIcon.classList.add('sj--icon-x');
    
    enquiryListCardDelete.textContent = 'Delete';
    enquiryListCardDelete.classList.add('delete-item');
    enquiryListCardDelete.setAttribute('data-item-index', index);
    /*
    let enquiryListCardLink = document.createElement("a");
    let enquiryListCardLinkIcon = document.createElement("i");
    enquiryListCardLinkIcon.classList.add('sj--icon-double-arrow-right');
    enquiryListCardLink.textContent = 'View';
    enquiryListCardLink.classList.add('item-link');
    enquiryListCardLink.setAttribute('href', enquiryitem.itemLink);
    */
    enquiryListCardActions.appendChild(enquiryListCardDelete);
    /*enquiryListCardActions.appendChild(enquiryListCardLink);*/
    enquiryListCardDelete.appendChild(enquiryListCardDeleteIcon);
    /*enquiryListCardLink.appendChild(enquiryListCardLinkIcon);*/
    enquiryListCard.append(enquiryListCardInfo);
    enquiryListCard.appendChild(enquiryListCardActions);

    let firstListCard = enquiryListFragment.firstChild
    enquiryListFragment.insertBefore(enquiryListCard , firstListCard);

    enquiryListCardDelete.onclick = function(e) {
        let latestEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
        let sidebar = document.querySelector(".enquiry-list-sidebar");
        sidebar.classList.add("deleting");

        let itemIndex = e.currentTarget.getAttribute('data-item-index');
        let itemID = e.currentTarget.closest('.enquiry-list-card[item-id]').getAttribute('item-id');
        latestEnquiryList.splice(itemIndex, 1);
        localStorage.setItem('enquirylist', JSON.stringify(latestEnquiryList));

        let deletedItem = document.querySelector('li[data-item-index="' + itemIndex + '"]');

        let cardItem = document.querySelector('.block-used-machine-card[item-id="' + itemID + '"]');

        let pageItem = document.querySelector('article.used-product-item[item-id="' + itemID + '"]');

        if (typeof(cardItem) != 'undefined' && cardItem != null) {
            let cardItemAddButton = cardItem.querySelector('.list-add');

            cardItemAddButton.removeAttribute("disabled", "");
            cardItemAddButton.querySelector('span').textContent = "Add To Enquiry List";
            cardItemAddButton.querySelector('i').classList.remove('sj--icon-enquiry');
            cardItemAddButton.querySelector('i').classList.add('sj--icon-plus');
        }

        if (typeof(pageItem) != 'undefined' && pageItem != null) {
            let pageItemAddButton = pageItem.querySelector('.list-add');

            pageItemAddButton.removeAttribute("disabled", "");
            pageItemAddButton.querySelector('span').textContent = "Add To Enquiry List";
            pageItemAddButton.querySelector('i').classList.remove('sj--icon-enquiry');
            pageItemAddButton.querySelector('i').classList.add('sj--icon-plus');
        }

        setTimeout(function() {
            deletedItem.remove();
            enquirylistcount();

            var otherItems = document.querySelectorAll(".enquiry-list-card");

            for (var y = 0; y < otherItems.length; y++) {
                otherItems[y].setAttribute("data-item-index", y);
                otherItems[y].querySelector("button").setAttribute("data-item-index", y);
            }

            sidebar.classList.remove("deleting");

            if (!enquiryUL.hasChildNodes()) {
                enquiryUL.parentNode.append(noItems);
            };

        }, 750);
    };

}


function search(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].itemID === nameKey) {
            return true;
        }
    }
}


function createDataArray (e) {
    let product = e.currentTarget.closest('article[item-id]');
    let itemID = product.getAttribute("item-id");

    let newEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
    if (!search(itemID, newEnquiryList)) {
        let data = [];
        let infoItems = product.querySelectorAll('.info-item');
        const itemCardImg = product.querySelector('img');
        const itemCardLink = product.querySelector('.bottom-button-content a.view-enquire');
        const itemPageLink = window.location.pathname;
        const itemPageImg = document.querySelector('img');
        let itemImg;
        let itemLink;

        if (typeof(itemCardImg) != 'undefined' && itemCardImg != null) {
            itemImg = itemCardImg.getAttribute('src');
        } else if(typeof(itemPageImg) != 'undefined' && itemPageImg != null) {
            itemImg = document.querySelector('.thumb-wrapper .thumb img').getAttribute('src');
        } else{
            itemImg = document.querySelector('img').getAttribute('src');
        }

        if (typeof(itemCardLink) != 'undefined' && itemCardLink != null) {
            itemLink = itemCardLink.getAttribute('href');
        } else if(typeof(itemPageLink) != 'undefined' && itemPageLink != null) {
            itemLink = itemPageLink;
        } else{
            itemLink ='';
        }
        
        for (var i = 0; i < infoItems.length; ++i) {
            let infoLabel = infoItems[i].getAttribute('data-label').toLowerCase();
            let infoData = infoItems[i].querySelector(".item-data").textContent;

            let dataArray = [infoLabel, infoData];

            let dataItem = { "data_item": dataArray };

            data.push(dataItem);
        }

        let machineryItem = {
            "itemID": itemID,
            "itemLink": itemLink,
            "itemImg": itemImg,
            "itemdata": '',
        }

        machineryItem.itemdata = data;

        let latestEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
        let itemIndex = latestEnquiryList.length;
        addEnquiryItem(machineryItem, itemIndex);

        latestEnquiryList.push(machineryItem);

        localStorage.setItem('enquirylist', JSON.stringify(latestEnquiryList));

        e.currentTarget.setAttribute("disabled", "");
        e.currentTarget.querySelector('span').textContent = "Added!";
        e.currentTarget.querySelector('i').classList.remove('sj--icon-plus');
        e.currentTarget.querySelector('i').classList.add('sj--icon-enquiry');

        enquirylistcount();

        enquiryUL.appendChild(enquiryListFragment);

    } else {
        let exists = document.querySelector('.enquiry-list-card[item-id="' + itemID + '"]');
        exists.classList.add('highlighted');
        let existsnotification = document.createElement("span");
        existsnotification.classList.add('existing-item');
        existsnotification.textContent = "Product is already on your enquiry list";
        exists.prepend(existsnotification);

        exists.scrollIntoView(true);

        setTimeout(function() {
            existsnotification.remove();
            exists.classList.remove('highlighted');
        }, 5000);
    }

};


document.arrive('.list-add', { existing: true }, function() {
    let productAdd = document.querySelectorAll(".list-add");
    for (var i = 0; i < productAdd.length; i++) {
        productAdd[i].addEventListener('click', createDataArray, false);
        productAdd[i].addEventListener('click', openEnquirySidebar, false);
    }
});

let closeEnquirySidebarButton = document.querySelector('.close-enquiry-sidebar');
let enquirySidebarOverlay = document.querySelector('.enquiry-bg-overlay');
if (typeof(closeEnquirySidebarButton) != 'undefined' && closeEnquirySidebarButton != null) {
    closeEnquirySidebarButton.addEventListener('click', closeEnquirySidebar, false);
    enquirySidebarOverlay.addEventListener('click', closeEnquirySidebar, false);

}

let openEnquirySidebarButton = document.querySelector('.open-enquiry-list');
if (typeof(openEnquirySidebarButton) != 'undefined' && openEnquirySidebarButton != null) {
    openEnquirySidebarButton.addEventListener('click', closeMainMenu, false);
    openEnquirySidebarButton.addEventListener('click', openEnquirySidebar, false);
}

function populateEnquiryList() {
    let latestEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");

    for (var i = 0, len = latestEnquiryList.length; i < len; i++) {
        let enquiryItem = latestEnquiryList[i];
        let itemIndex = i;

        addEnquiryItem(enquiryItem, itemIndex);
    }
}


function isEnquiryListEmpty() {
    if (!enquiryUL.hasChildNodes()) {
        enquiryUL.parentNode.append(noItems);
    } else {
        noItems.remove();
    }
}

window.onload = function() {
    enquirylistcount();
    populateEnquiryList();
    enquiryUL.appendChild(enquiryListFragment);
    isEnquiryListEmpty();
}


function fillEnquireNowFrom(formSelector) {
    let finalEnquiryList = JSON.parse(localStorage.getItem("enquirylist") || "[]");
    if(finalEnquiryList.length == 0){
        return;
    }
    
    let messageContent;
    messageContent = "Hello, I would like to enquire about the following: ";

    for (let i = 0; i < finalEnquiryList.length; i++) {
        let enquiryItem = finalEnquiryList[i];
        let modelTitle,
            refNo;
        for (let i = 0; i < enquiryItem.itemdata.length; i++) {
            let dataLabel = enquiryItem.itemdata[i].data_item[0];

            if(dataLabel == 'model'){
                modelTitle = enquiryItem.itemdata[i].data_item[1];
            }
            if(dataLabel == 'serialno'){
                refNo = enquiryItem.itemdata[i].data_item[1];
            }
        }

        messageContent = `${messageContent}\r\n${modelTitle}  -  Serial No: ${refNo}, `;
    }
    let messageTextarea = formSelector.querySelector('.message');
    messageTextarea.value = messageContent;
    autosize(messageTextarea);

    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
            autosize.update(messageTextarea)
        }, 200);
     }, false);
}